"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _BaseClient2 = _interopRequireDefault(require("./BaseClient"));

var PricingTermClient =
/*#__PURE__*/
function (_BaseClient) {
  (0, _inherits2["default"])(PricingTermClient, _BaseClient);

  function PricingTermClient(getAccessToken, isProduction) {
    (0, _classCallCheck2["default"])(this, PricingTermClient);
    return (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(PricingTermClient).call(this, getAccessToken, isProduction ? 'https://pricingterm.ff.cimpress.io' : 'https://stg-pricingterm.ff.cimpress.io'));
  }

  (0, _createClass2["default"])(PricingTermClient, [{
    key: "createCatalogPriceTerm",
    value: function createCatalogPriceTerm(sellerFulfillerId, buyerMerchantId, skus, name) {
      var additionalData = {
        name: name
      };
      var fulfillerObj = {
        type: 'fulfillers',
        id: sellerFulfillerId
      };
      var merchantObj = {
        type: 'merchants',
        id: buyerMerchantId
      };
      var body = {
        skus: skus,
        initiator: fulfillerObj,
        acceptor: merchantObj,
        buyer: merchantObj,
        seller: fulfillerObj,
        additionalData: additionalData,
        toPendingStatus: true
      };
      return this.fetchWithAuth({
        endpointUrl: this.endpointUrl,
        route: "api/v0/listPriceTerms",
        method: 'POST',
        body: body,
        additionalHeaders: {
          accept: 'application/hal+json'
        }
      });
    }
  }]);
  return PricingTermClient;
}(_BaseClient2["default"]);

exports["default"] = PricingTermClient;